import PropTypes from 'prop-types';

import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';

const CustomStepper = ({ steps, stepIndex }) => {
  return(
    <Box sx={{width: '100%'}} mt={2}>
      <Stepper 
        activeStep={stepIndex} 
        alternativeLabel 
        sx={{ 
          '& .MuiStepLabel-label': { fontSize: '0.75rem' }, 
          '& .MuiStepConnector-line': { minHeight: '1px' }, 
        }}
      >
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
    </Box>
  );
};

CustomStepper.propTypes = {
  steps: PropTypes.array.isRequired,
  stepIndex: PropTypes.number.isRequired,
};

export default CustomStepper;